import {Component, Input} from '@angular/core';
import {Room} from '../../../models/room';
import {MoneyPipe} from '../../pipes/money.pipe';
import {RouterLink} from '@angular/router';
import {CurrencyPipe} from '@angular/common';

@Component({
  selector: 'app-room-rectangle',
  imports: [
    MoneyPipe,
    RouterLink
  ],
  providers: [CurrencyPipe],
  templateUrl: './room-rectangle.component.html',
  styleUrl: './room-rectangle.component.scss'
})
export class RoomRectangleComponent {

  @Input() room!: Room

}
